<template>
  <div class="hospital-layout">
    <layout-header></layout-header>
    <div class="hospital-layout-content">
      <router-view />
      <layout-footer></layout-footer>
    </div>
    <upload-container :config="uploadConfig" :data.sync="fileData" v-if="isShowUpload" @close="closeUpload"
      @change="tabChange" :fileItemConfig="fileItemConfig" style="bottom: 0;"
      class="upload-container"></upload-container>
  </div>
</template>

<script>
import LayoutFooter from "./layoutFooter";
import LayoutHeader from "./layoutHeader";

export default {
  components: { LayoutHeader, LayoutFooter },
  computed: {
    isShowContainer() {
      return this.$store.state.file.isShowContainer;
    },
    fileList() {
      return this.$store.state.file.fileList;
    }
  },
  watch: {
    fileList(val) {
      let self = this;
      val.map(item => {
        item.index = self.getMaxIndex() + 1;
        self.uploadList.push(item);
        item.file.uploadId = "file" + new Date().getTime();
        self.getFqUploadUrl().then(url => {
          console.log("updateurl", url)
          // 获得上传地址
          self.startAjaxUpload(item).then(
            res => {
              // 开始上传
              item._upload_fData = res.data ? res.data.data : {};
              self.uploadByTus(item, item.index, url, fileItem => {
                // fq上传
                self.endAjaxUpload(item).then(
                  res => {
                    const result = [];
                    self.uploadList.map(uitem => {
                      if (uitem.index != fileItem.index) {
                        result.push(uitem);
                      }
                    });
                    self.uploadList = result;
                    self.reloadFileData();
                    self.$store.commit("file/setReload", true);
                  },
                  err => {
                    self.errorAjaxUpload(item).then(res => {
                      const fileItem = this.uploadList.find(d => {
                        return d.index == item.index;
                      });
                      self.$store.commit("file/setReload", true);
                      if (!fileItem) return;
                      self.failList.push(fileItem);
                      setTimeout(() => {
                        const result = [];
                        self.uploadList.map(uitem => {
                          if (uitem.index != fileItem.index) {
                            result.push(uitem);
                          }
                        });
                        self.uploadList = result;
                        self.reloadFileData();
                      }, 400);
                      self.reloadFileData();
                      self.$message.error(fileItem.title + "上传失败");
                    });
                  }
                ); // 结束上传
              });
            },
            err => {
              const fileItem = this.uploadList.find(d => {
                return d.index == item.index;
              });
              self.$store.commit("file/setReload", true);
              if (!fileItem) return;
              self.failList.push(fileItem);
              setTimeout(() => {
                const result = [];
                self.uploadList.map(uitem => {
                  if (uitem.index != fileItem.index) {
                    result.push(uitem);
                  }
                });
                self.uploadList = result;
                self.reloadFileData();
              }, 400);
              self.reloadFileData();
              // this.$message.error(fileItem.title + "上传失败");
            }
          );
        });
      });
      self.uploadAry = self.uploadList.concat([]);
      // this.startUpload();
      self.reloadFileData();
    },
    isShowContainer(val) {
      this.isShowUpload = val;

    }
  },
  data() {
    return {
      data: [],
      uploadList: [],
      failList: [],
      uploadAry: [],
      fileData: [],
      isShowUpload: false,
      currentTab: "upload",
      fileItemConfig: {
        command: (type, item) => {
          const self = this;
          const tab = type.split("|");
          if (tab[0] == "upload") {
            this["upload" + tab[1]](item);
            // 删除上传
            // this.deleteUploadding(file)
          }
          if (tab[0] == "fail") {
            // 重新上传
            // this.refreshFileByLocal(file)
            this.$tusUpload.delete(item.file.uploadId);
            this.getFqUploadUrl().then(url => {
              // 获得上传地址
              this.startAjaxUpload(item).then(res => {
                // 开始上传
                item._upload_fData = res.data ? res.data.data : null;
                this.uploadByTus(item, item.index, url, fileItem => {
                  // fq上传
                  this.endAjaxUpload(item).then(
                    res => {
                      const result = [];
                      this.uploadList.map(uitem => {
                        if (uitem.index != fileItem.index) {
                          result.push(uitem);
                        }
                      });
                      this.uploadList = result;
                      this.reloadFileData();
                      this.$store.commit("file/setReload", true);
                    },
                    err => {
                      this.errorAjaxUpload(item).then(() => {
                        const fileItem = this.uploadList.find(d => {
                          return d.index == item.index;
                        });
                        this.$store.commit("file/setReload", true);
                        if (!fileItem) return;
                        this.failList.push(fileItem);
                        setTimeout(() => {
                          const result = [];
                          this.uploadList.map(uitem => {
                            if (uitem.index != fileItem.index) {
                              result.push(uitem);
                            }
                          });
                          this.uploadList = result;
                          this.reloadFileData();
                        }, 400);
                        this.reloadFileData();
                        this.$message.error(fileItem.title + "上传失败");
                      });
                    }
                  ); // 结束上传
                });
              });
            });
          }
        }
      },
      uploadConfig: {
        tabs: [
          {
            title: "上传中",
            tab: "upload"
          },
          {
            title: "上传失败",
            tab: "fail"
          }
        ]
      }
    };
  },
  created() {
    //
  },
  methods: {
    cancelAjaxUpload(item) {
      return new Promise((resolve, reject) => {
        this.$post(
          "uploadfq/uploadFq/uploadFq?operateType=fq-upload-cancel",
          item._upload_fData,
          true
        ).then(
          res => {
            resolve(res);
            this.$message.success("文件取消成功");
          },
          err => {
            reject(err);
          }
        );
      });
    },
    endAjaxUpload(item) {
      return new Promise((resolve, reject) => {
        this.$post(
          "uploadfq/uploadFq/uploadFq?operateType=fq-upload-success",
          item._upload_fData,
          true
        ).then(
          res => {
            resolve(res);
            if (res.data.message.indexOf('md5校验未通过') > -1) {
              this.$message.error(res.data.message);
            } else {
              this.$message.success("文件上传成功");
            }
          },
          err => {
            reject(err);
          }
        );
      });
    },
    errorAjaxUpload(item) {
      return new Promise((resolve, reject) => {
        this.$post(
          "uploadfq/uploadFq/uploadFq?operateType=fq-upload-failed",
          item._upload_fData,
          true
        ).then(
          res => {
            resolve(res);
          },
          err => {
            reject(err);
          }
        );
      });
    },
    startAjaxUpload(item) {
      let self = this;
      return new Promise((resolve, reject) => {
        let fromData = {
          bid: item._data.id,
          fileName: item.fileName,
          fileSize: item.file.size,
          // fileType: item.file.type,
          applyItemName: item._data.applyItemName,
          barCode: item._data.barCode,
          hosBarCode: item._data.hosBarCode
        };
        this.$post(
          "uploadfq/uploadFq/uploadFq?operateType=fq-upload",
          fromData,
          true
        ).then(
          res => {
            resolve(res);
          },
          err => {
            self.$message.error(err.response.data.message);
            reject(err);
          }
        );
      });
    },
    tabChange(tab) {
      this.currentTab = tab;
      if (tab == "upload") {
        this.fileData = this.uploadList;
        this.fileData.map(item => {
          if (item) {
            item.type = tab;
          }
        });
      } else if (tab == "fail") {
        this.fileData = this.failList;
        this.fileData.map(item => {
          if (item) {
            item.type = tab;
          }
        });
      } else {
        this.fileData = [];
      }
    },
    uploadresume(item) {
      // 恢复上传
      this.$tusUpload.tusUploadEle[item.file.uploadId].start();
    },
    uploadpause(item) {
      //  暂停上传
      this.$tusUpload.pause(item.file.uploadId);
    },
    uploadclose(item) {
      // 删除上传文件
      const self = this;
      const result = [];
      this.$confirm({
        title: "提示",
        content: "此文件正在上传，您确定要删除此文件吗？",
        okText: "确定",
        okType: "primary",
        cancelText: "取消",
        onOk: () => {
          self.uploadList.map(d => {
            if (item.index != d.index) {
              result.push(d);
            }
          });
          self.uploadList = result.concat([]);
          self.cancelAjaxUpload(item);
          self.$tusUpload.delete(item.file.uploadId);
          self.reloadFileData();
        },
        onCancel() {
        }
      });
    },
    reloadFileData() {
      if (this.currentTab == "upload") {
        this.fileData = this.uploadList;
        this.fileData.map(item => {
          if (item) {
            item.type = this.currentTab;
          }
        });
      }
      if (this.currentTab == "fail") {
        this.fileData = this.failList;
        this.fileData.map(item => {
          if (item) {
            item.type = this.currentTab;
          }
        });
      }
    },
    getMaxIndex() {
      let index = 0;
      this.uploadList.map(item => {
        if (item.index > index) {
          index = item.index;
        }
      });
      return index;
    },
    getFqUploadUrl() {
      return new Promise((resolve, reject) => {
        let fileList = this.$store.state.file.fileList;
        let patientItemId = fileList[0]._data ? fileList[0]._data.id : '';
        this.$get("patientitem/patientItem/getFqUploadPath?patientItemId=" + patientItemId + "").then(
          res => {
            resolve(res.data.data);
          },
          err => {
            reject(err);
          }
        );
      });
    },
    closeUpload() {
      if (this.uploadList.length > 0) {
        this.$confirm({
          title: "提示",
          content: "有文件正在上传，您确定要关闭吗？",
          okText: "确定",
          okType: "primary",
          cancelText: "取消",
          onOk: () => {
            this.uploadList = [];
            this.failList = [];
            this.isShowUpload = false;
            this.$store.commit("file/setShowContainer", false);
            // this.cancelAjaxUpload(item);
          },
          onCancel() {
          }
        });
      } else {
        this.isShowUpload = false;
        this.$store.commit("file/setShowContainer", false);
        this.uploadList = [];
        this.failList = [];
      }
    },
    uploadByTus(item, index, url, callback) {
      const fileItem = this.uploadList.find(d => {
        return d.index == index;
      });
      this.$tusUpload
        .upload("" + process.env.VUE_APP_TUS_UPLOAD_URL + "/uploads",
          item.file,
          item.fileName,
          {
            nameDisplay: true,
            user: url
          },
          {
            onProgress: (bytesUploaded, bytesTotal, percentage) => {
              fileItem.percent = parseInt(percentage);
            }
          }
        )
        .then(
          res => {
            if (callback) callback(fileItem);
          },
          err => {
            this.errorAjaxUpload(item).then(() => {
              const fileItem = this.uploadList.find(d => {
                return d.index == index;
              });
              if (fileItem) {
                this.failList.push(fileItem);
                setTimeout(() => {
                  const result = [];
                  this.uploadList.map(item => {
                    if (item.index != fileItem.index) {
                      result.push(item);
                    }
                  });
                  this.uploadList = result;
                  this.reloadFileData();
                }, 400);
                this.reloadFileData();
                this.$message.error(fileItem.title + "上传失败");
              }
            });
          }
        );
    }
  }
};
</script>

<style lang="scss" scoped>
.hospital-layout {
  width: 100%;
  height: 100%;

  .hospital-layout-content {
    padding-top: 80px;
  }
}

.upload-container {
  width: 583px;
  position: fixed;
  right: 24px;
  z-index: 99;
}

@media only screen and (min-width: 1580px) {
  .hospital-layout-content {
    padding-top: 80px !important;
  }
}
</style>